module.exports = __webpack_public_path__ + "img/07.1cee2a88.png";